import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { firestore } from 'firebase/app';
import { OappService } from 'src/app/shared/services/oapp.service';

import { map, take, debounceTime, first } from 'rxjs/operators';

import { forkJoin } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CurBaseService {
  public link = '';
  public cargoparametrosb = false;
  docId: string;

  constructor(public oapp: OappService, public db: AngularFirestore) {
    console.log('constructor servico CurBaseService', this.link);
    let prop = {
      nit: '564782345-9',
      nombre: 'Condominio Palo Alto',
      ciudad: 'La Mesa',
      pais: 'Colombia',
      direccion: 'Calle 1a # 23a-16',
      telefono: 487395285,
      parNetsolin:{
        prefijoemprenetsolin : 'SITC',
      usuarionetsolin : 'NETSDESAA'
      }

    }

    // let users: any = [
    //   {
    //     "primerNombre": "Alvin",
    //     "segundoNombre": "Wylie",
    //     "primerApellido": "Reeves",
    //     "segundoApellido": "Henson",
    //     "tipoID": "CC",
    //     "id": "6449714822",
    //     "fechaNacimiento": "16/03/1982",
    //     "email": "sit.amet@google.org",
    //     "emailSecundario": "suspendisse.eleifend@hotmail.org",
    //     "telefono": 8779362613,
    //     "eps": "Compensar",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Uriah",
    //     "segundoNombre": "Zachary",
    //     "primerApellido": "Tate",
    //     "segundoApellido": "Carpenter",
    //     "tipoID": "CC",
    //     "id": "5596760704",
    //     "fechaNacimiento": "10/11/1989",
    //     "email": "et.ipsum@icloud.com",
    //     "emailSecundario": "feugiat@hotmail.comco",
    //     "telefono": 2223831834,
    //     "eps": "Compensar",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Cyrus",
    //     "segundoNombre": "Dexter",
    //     "primerApellido": "Cummings",
    //     "segundoApellido": "Hopkins",
    //     "tipoID": "CC",
    //     "id": "9364884537",
    //     "fechaNacimiento": "22/11/1944",
    //     "email": "sodales.elit@outlook.com",
    //     "emailSecundario": "dolor.vitae.dolor@outlook.net",
    //     "telefono": 2558616504,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Owen",
    //     "segundoNombre": "Iliana",
    //     "primerApellido": "Parsons",
    //     "segundoApellido": "Britt",
    //     "tipoID": "CC",
    //     "id": "8622646342",
    //     "fechaNacimiento": "26/05/1988",
    //     "email": "sed.sem.egestas@hotmail.edu",
    //     "emailSecundario": "justo.nec.ante@hotmail.co",
    //     "telefono": 8656419158,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Steel",
    //     "segundoNombre": "Daniel",
    //     "primerApellido": "Avila",
    //     "segundoApellido": "Harris",
    //     "tipoID": "CC",
    //     "id": "5275359648",
    //     "fechaNacimiento": "16/11/1955",
    //     "email": "luctus.felis@outlook.net",
    //     "emailSecundario": "eu.eros.nam@hotmail.comco",
    //     "telefono": 3380246232,
    //     "eps": "Compensar",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Acton",
    //     "segundoNombre": "Ivor",
    //     "primerApellido": "Madden",
    //     "segundoApellido": "Walls",
    //     "tipoID": "CC",
    //     "id": "4068101226",
    //     "fechaNacimiento": "20/09/2004",
    //     "email": "lacus@google.co",
    //     "emailSecundario": "eu.placerat.eget@hotmail.comco",
    //     "telefono": 3389556868,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Hilel",
    //     "segundoNombre": "Kevin",
    //     "primerApellido": "White",
    //     "segundoApellido": "Quinn",
    //     "tipoID": "CC",
    //     "id": "9213768863",
    //     "fechaNacimiento": "04/05/1992",
    //     "email": "neque.morbi@google.co",
    //     "emailSecundario": "etiam.laoreet.libero@google.net",
    //     "telefono": 5642554424,
    //     "eps": "Compensar",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Bevis",
    //     "segundoNombre": "Lyle",
    //     "primerApellido": "Green",
    //     "segundoApellido": "Brown",
    //     "tipoID": "CC",
    //     "id": "2667575527",
    //     "fechaNacimiento": "26/11/1943",
    //     "email": "eu.dui.cum@icloud.comco",
    //     "emailSecundario": "nunc@google.co",
    //     "telefono": 8146776671,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Jerome",
    //     "segundoNombre": "Christen",
    //     "primerApellido": "Mcneil",
    //     "segundoApellido": "Mueller",
    //     "tipoID": "CC",
    //     "id": "6212713840",
    //     "fechaNacimiento": "26/08/1936",
    //     "email": "semper.egestas@outlook.edu",
    //     "emailSecundario": "sapien.nunc.pulvinar@google.edu",
    //     "telefono": 2085767044,
    //     "eps": "Sura",
    //     "tipoSangre": "AB+"
    //   },
    //   {
    //     "primerNombre": "Priscilla",
    //     "segundoNombre": "Jermaine",
    //     "primerApellido": "Dalton",
    //     "segundoApellido": "Mueller",
    //     "tipoID": "CC",
    //     "id": "9582448007",
    //     "fechaNacimiento": "30/04/1975",
    //     "email": "penatibus.et.magnis@outlook.comco",
    //     "emailSecundario": "egestas.aliquam.nec@icloud.comco",
    //     "telefono": 1687381417,
    //     "eps": "Sura",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "McKenzie",
    //     "segundoNombre": "Matthew",
    //     "primerApellido": "Melton",
    //     "segundoApellido": "Dudley",
    //     "tipoID": "CC",
    //     "id": "2765284413",
    //     "fechaNacimiento": "27/12/1993",
    //     "email": "vel.faucibus@hotmail.comco",
    //     "emailSecundario": "fusce.mi.lorem@google.org",
    //     "telefono": 4114296180,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Zena",
    //     "segundoNombre": "Beverly",
    //     "primerApellido": "Hayden",
    //     "segundoApellido": "Herman",
    //     "tipoID": "CC",
    //     "id": "2651489676",
    //     "fechaNacimiento": "26/01/2006",
    //     "email": "dolor.egestas.rhoncus@icloud.org",
    //     "emailSecundario": "quisque.porttitor.eros@outlook.net",
    //     "telefono": 4478014403,
    //     "eps": "Compensar",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Macaulay",
    //     "segundoNombre": "Farrah",
    //     "primerApellido": "Rich",
    //     "segundoApellido": "Bruce",
    //     "tipoID": "CC",
    //     "id": "5380529894",
    //     "fechaNacimiento": "30/03/1975",
    //     "email": "augue.malesuada@outlook.com",
    //     "emailSecundario": "eleifend.non@outlook.org",
    //     "telefono": 8301620374,
    //     "eps": "Compensar",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Rogan",
    //     "segundoNombre": "Shaine",
    //     "primerApellido": "Dawson",
    //     "segundoApellido": "Waters",
    //     "tipoID": "CC",
    //     "id": "7155237825",
    //     "fechaNacimiento": "17/11/2005",
    //     "email": "imperdiet@icloud.org",
    //     "emailSecundario": "sit.amet.ante@outlook.co",
    //     "telefono": 5542702754,
    //     "eps": "Compensar",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Philip",
    //     "segundoNombre": "Chandler",
    //     "primerApellido": "Harrison",
    //     "segundoApellido": "Diaz",
    //     "tipoID": "CC",
    //     "id": "5744368026",
    //     "fechaNacimiento": "02/04/1990",
    //     "email": "consectetuer.mauris@yahoo.net",
    //     "emailSecundario": "ut.sagittis@hotmail.org",
    //     "telefono": 4145183895,
    //     "eps": "Compensar",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Shea",
    //     "segundoNombre": "Rhiannon",
    //     "primerApellido": "Wilkinson",
    //     "segundoApellido": "Smith",
    //     "tipoID": "CC",
    //     "id": "4273478221",
    //     "fechaNacimiento": "10/02/1995",
    //     "email": "justo.faucibus@yahoo.com",
    //     "emailSecundario": "nec.tempus.scelerisque@hotmail.org",
    //     "telefono": 8434163954,
    //     "eps": "Compensar",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Marny",
    //     "segundoNombre": "Karly",
    //     "primerApellido": "Medina",
    //     "segundoApellido": "Blanchard",
    //     "tipoID": "CC",
    //     "id": "6962628349",
    //     "fechaNacimiento": "17/07/1954",
    //     "email": "est@outlook.co",
    //     "emailSecundario": "elit.curabitur.sed@hotmail.org",
    //     "telefono": 5836772719,
    //     "eps": "Sura",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Isabella",
    //     "segundoNombre": "Leslie",
    //     "primerApellido": "Britt",
    //     "segundoApellido": "Landry",
    //     "tipoID": "CC",
    //     "id": "2543067229",
    //     "fechaNacimiento": "28/04/2000",
    //     "email": "malesuada.vel@hotmail.comco",
    //     "emailSecundario": "et.ipsum@yahoo.comco",
    //     "telefono": 3282412139,
    //     "eps": "Compensar",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Neville",
    //     "segundoNombre": "Gray",
    //     "primerApellido": "Miranda",
    //     "segundoApellido": "Valdez",
    //     "tipoID": "CC",
    //     "id": "8461978472",
    //     "fechaNacimiento": "08/09/2005",
    //     "email": "ornare.sagittis@outlook.net",
    //     "emailSecundario": "cum@yahoo.com",
    //     "telefono": 7347641880,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Avram",
    //     "segundoNombre": "Tatyana",
    //     "primerApellido": "Hansen",
    //     "segundoApellido": "Pope",
    //     "tipoID": "CC",
    //     "id": "5532608338",
    //     "fechaNacimiento": "29/07/1940",
    //     "email": "eget.venenatis@icloud.com",
    //     "emailSecundario": "massa@google.edu",
    //     "telefono": 2265564088,
    //     "eps": "Sura",
    //     "tipoSangre": "AB+"
    //   },
    //   {
    //     "primerNombre": "Anne",
    //     "segundoNombre": "Kathleen",
    //     "primerApellido": "Gilmore",
    //     "segundoApellido": "Roberson",
    //     "tipoID": "CC",
    //     "id": "5802546996",
    //     "fechaNacimiento": "17/12/1982",
    //     "email": "mauris.molestie@hotmail.comco",
    //     "emailSecundario": "sem@google.edu",
    //     "telefono": 4517549411,
    //     "eps": "Sura",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Donna",
    //     "segundoNombre": "Kasper",
    //     "primerApellido": "Hogan",
    //     "segundoApellido": "Haney",
    //     "tipoID": "CC",
    //     "id": "1847562333",
    //     "fechaNacimiento": "30/03/1973",
    //     "email": "enim.nisl.elementum@google.comco",
    //     "emailSecundario": "accumsan@icloud.comco",
    //     "telefono": 4658823930,
    //     "eps": "Sura",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Zachery",
    //     "segundoNombre": "Buckminster",
    //     "primerApellido": "Rodriquez",
    //     "segundoApellido": "Fitzgerald",
    //     "tipoID": "CC",
    //     "id": "2391556609",
    //     "fechaNacimiento": "09/05/1955",
    //     "email": "amet@hotmail.comco",
    //     "emailSecundario": "auctor@icloud.org",
    //     "telefono": 2833624842,
    //     "eps": "Sura",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Skyler",
    //     "segundoNombre": "Miriam",
    //     "primerApellido": "Griffith",
    //     "segundoApellido": "Montoya",
    //     "tipoID": "CC",
    //     "id": "3648346660",
    //     "fechaNacimiento": "11/09/1996",
    //     "email": "consequat.dolor@yahoo.edu",
    //     "emailSecundario": "orci.consectetuer@outlook.org",
    //     "telefono": 2254686353,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Carly",
    //     "segundoNombre": "Jacob",
    //     "primerApellido": "Medina",
    //     "segundoApellido": "Hudson",
    //     "tipoID": "CC",
    //     "id": "8653617957",
    //     "fechaNacimiento": "09/12/1998",
    //     "email": "quam.elementum.at@yahoo.net",
    //     "emailSecundario": "nulla.eu.neque@hotmail.net",
    //     "telefono": 2085461425,
    //     "eps": "Sura",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Jillian",
    //     "segundoNombre": "Wallace",
    //     "primerApellido": "Jacobson",
    //     "segundoApellido": "Osborn",
    //     "tipoID": "CC",
    //     "id": "6478681301",
    //     "fechaNacimiento": "14/06/1942",
    //     "email": "ipsum.cursus.vestibulum@google.org",
    //     "emailSecundario": "vel.vulputate@yahoo.com",
    //     "telefono": 4913526816,
    //     "eps": "Sanitas",
    //     "tipoSangre": "A-"
    //   },
    //   {
    //     "primerNombre": "Catherine",
    //     "segundoNombre": "Dane",
    //     "primerApellido": "Young",
    //     "segundoApellido": "Finley",
    //     "tipoID": "CC",
    //     "id": "5657371905",
    //     "fechaNacimiento": "12/07/1956",
    //     "email": "eu.odio@hotmail.edu",
    //     "emailSecundario": "ornare.elit@yahoo.co",
    //     "telefono": 7222756665,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB+"
    //   },
    //   {
    //     "primerNombre": "Louis",
    //     "segundoNombre": "Jacqueline",
    //     "primerApellido": "Mullen",
    //     "segundoApellido": "Santos",
    //     "tipoID": "CC",
    //     "id": "7686795378",
    //     "fechaNacimiento": "17/07/1972",
    //     "email": "lorem.eu@outlook.edu",
    //     "emailSecundario": "lorem@google.net",
    //     "telefono": 8955377651,
    //     "eps": "Compensar",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Ferris",
    //     "segundoNombre": "Nissim",
    //     "primerApellido": "Mcdowell",
    //     "segundoApellido": "Greene",
    //     "tipoID": "CC",
    //     "id": "7641512278",
    //     "fechaNacimiento": "20/07/2004",
    //     "email": "cras.dolor.dolor@hotmail.co",
    //     "emailSecundario": "vel.convallis@google.com",
    //     "telefono": 6623008766,
    //     "eps": "Compensar",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Dawn",
    //     "segundoNombre": "Lucius",
    //     "primerApellido": "Holmes",
    //     "segundoApellido": "Henson",
    //     "tipoID": "CC",
    //     "id": "1341314622",
    //     "fechaNacimiento": "22/06/1977",
    //     "email": "vitae.aliquet@icloud.org",
    //     "emailSecundario": "tellus.eu@outlook.co",
    //     "telefono": 7638537253,
    //     "eps": "Compensar",
    //     "tipoSangre": "AB+"
    //   },
    //   {
    //     "primerNombre": "Bruce",
    //     "segundoNombre": "Kylan",
    //     "primerApellido": "Kaufman",
    //     "segundoApellido": "Mcintosh",
    //     "tipoID": "CC",
    //     "id": "7322661480",
    //     "fechaNacimiento": "27/04/1963",
    //     "email": "ut.semper@hotmail.co",
    //     "emailSecundario": "libero.et@yahoo.net",
    //     "telefono": 9353947361,
    //     "eps": "Compensar",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Jorden",
    //     "segundoNombre": "Yael",
    //     "primerApellido": "Stein",
    //     "segundoApellido": "Contreras",
    //     "tipoID": "CC",
    //     "id": "2448176208",
    //     "fechaNacimiento": "18/03/1950",
    //     "email": "nec.tempus@google.com",
    //     "emailSecundario": "cubilia.curae.donec@hotmail.co",
    //     "telefono": 5024683553,
    //     "eps": "Sura",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Erin",
    //     "segundoNombre": "Adele",
    //     "primerApellido": "Whitfield",
    //     "segundoApellido": "Malone",
    //     "tipoID": "CC",
    //     "id": "6821935853",
    //     "fechaNacimiento": "19/08/2009",
    //     "email": "proin.ultrices@icloud.com",
    //     "emailSecundario": "elementum.purus.accumsan@icloud.edu",
    //     "telefono": 5422563413,
    //     "eps": "Compensar",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Wanda",
    //     "segundoNombre": "Gay",
    //     "primerApellido": "Cleveland",
    //     "segundoApellido": "Vega",
    //     "tipoID": "CC",
    //     "id": "4172317221",
    //     "fechaNacimiento": "18/07/1950",
    //     "email": "interdum.libero.dui@icloud.org",
    //     "emailSecundario": "semper@google.comco",
    //     "telefono": 4131678668,
    //     "eps": "Compensar",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Randall",
    //     "segundoNombre": "Elvis",
    //     "primerApellido": "Brady",
    //     "segundoApellido": "Ashley",
    //     "tipoID": "CC",
    //     "id": "9209147172",
    //     "fechaNacimiento": "20/04/1997",
    //     "email": "dictum.eu@yahoo.co",
    //     "emailSecundario": "mi.tempor.lorem@icloud.co",
    //     "telefono": 9692885178,
    //     "eps": "Sura",
    //     "tipoSangre": "A-"
    //   },
    //   {
    //     "primerNombre": "Kaye",
    //     "segundoNombre": "Audrey",
    //     "primerApellido": "Rogers",
    //     "segundoApellido": "Harrison",
    //     "tipoID": "CC",
    //     "id": "6363892452",
    //     "fechaNacimiento": "24/08/1993",
    //     "email": "natoque@icloud.comco",
    //     "emailSecundario": "id.nunc.interdum@yahoo.comco",
    //     "telefono": 3166473346,
    //     "eps": "Sura",
    //     "tipoSangre": "AB+"
    //   },
    //   {
    //     "primerNombre": "Hasad",
    //     "segundoNombre": "Hadley",
    //     "primerApellido": "Nolan",
    //     "segundoApellido": "Koch",
    //     "tipoID": "CC",
    //     "id": "8558633184",
    //     "fechaNacimiento": "01/06/1955",
    //     "email": "porttitor.eros@google.co",
    //     "emailSecundario": "sem@icloud.edu",
    //     "telefono": 3307353150,
    //     "eps": "Sura",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Eleanor",
    //     "segundoNombre": "Damon",
    //     "primerApellido": "Garrison",
    //     "segundoApellido": "Greene",
    //     "tipoID": "CC",
    //     "id": "3752476826",
    //     "fechaNacimiento": "08/12/1997",
    //     "email": "ante.vivamus@icloud.com",
    //     "emailSecundario": "eu.accumsan.sed@google.com",
    //     "telefono": 9981802406,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Shaeleigh",
    //     "segundoNombre": "Dora",
    //     "primerApellido": "Casey",
    //     "segundoApellido": "Page",
    //     "tipoID": "CC",
    //     "id": "3090243562",
    //     "fechaNacimiento": "01/01/1938",
    //     "email": "donec.egestas@hotmail.com",
    //     "emailSecundario": "vitae@google.org",
    //     "telefono": 3626283944,
    //     "eps": "Sura",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Olympia",
    //     "segundoNombre": "Lamar",
    //     "primerApellido": "Delaney",
    //     "segundoApellido": "Foley",
    //     "tipoID": "CC",
    //     "id": "6484765258",
    //     "fechaNacimiento": "16/12/1964",
    //     "email": "pede.nunc@outlook.org",
    //     "emailSecundario": "augue.sed@outlook.edu",
    //     "telefono": 7286704585,
    //     "eps": "Sura",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Xaviera",
    //     "segundoNombre": "Wyoming",
    //     "primerApellido": "Parsons",
    //     "segundoApellido": "Miles",
    //     "tipoID": "CC",
    //     "id": "3470156276",
    //     "fechaNacimiento": "15/11/1958",
    //     "email": "lectus.ante.dictum@icloud.edu",
    //     "emailSecundario": "lacinia.at@icloud.net",
    //     "telefono": 3713212195,
    //     "eps": "Sura",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Leslie",
    //     "segundoNombre": "Gray",
    //     "primerApellido": "Benson",
    //     "segundoApellido": "Fry",
    //     "tipoID": "CC",
    //     "id": "4564841759",
    //     "fechaNacimiento": "13/05/1936",
    //     "email": "facilisi.sed.neque@hotmail.co",
    //     "emailSecundario": "nibh.donec.est@yahoo.comco",
    //     "telefono": 6614847262,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Kato",
    //     "segundoNombre": "Xanthus",
    //     "primerApellido": "Orr",
    //     "segundoApellido": "Simon",
    //     "tipoID": "CC",
    //     "id": "3140272389",
    //     "fechaNacimiento": "28/04/1984",
    //     "email": "enim.sit.amet@outlook.edu",
    //     "emailSecundario": "arcu.vestibulum@outlook.org",
    //     "telefono": 3864036545,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Justina",
    //     "segundoNombre": "Armand",
    //     "primerApellido": "Newman",
    //     "segundoApellido": "Walton",
    //     "tipoID": "CC",
    //     "id": "7221319034",
    //     "fechaNacimiento": "22/11/1971",
    //     "email": "erat@yahoo.com",
    //     "emailSecundario": "nulla@google.co",
    //     "telefono": 6061224838,
    //     "eps": "Compensar",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Velma",
    //     "segundoNombre": "Maris",
    //     "primerApellido": "Mcbride",
    //     "segundoApellido": "English",
    //     "tipoID": "CC",
    //     "id": "7248765986",
    //     "fechaNacimiento": "16/05/1966",
    //     "email": "felis.donec@google.net",
    //     "emailSecundario": "vulputate.mauris@yahoo.net",
    //     "telefono": 5270333421,
    //     "eps": "Sura",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Jasper",
    //     "segundoNombre": "Lucas",
    //     "primerApellido": "Winters",
    //     "segundoApellido": "Greene",
    //     "tipoID": "CC",
    //     "id": "8407670743",
    //     "fechaNacimiento": "29/06/2002",
    //     "email": "sodales.purus.in@outlook.net",
    //     "emailSecundario": "duis.ac.arcu@hotmail.net",
    //     "telefono": 2275235575,
    //     "eps": "Sanitas",
    //     "tipoSangre": "A-"
    //   },
    //   {
    //     "primerNombre": "Aileen",
    //     "segundoNombre": "Laith",
    //     "primerApellido": "Mccoy",
    //     "segundoApellido": "Weaver",
    //     "tipoID": "CC",
    //     "id": "5704839883",
    //     "fechaNacimiento": "31/10/1960",
    //     "email": "magna.lorem.ipsum@outlook.org",
    //     "emailSecundario": "feugiat.lorem@hotmail.com",
    //     "telefono": 6467459825,
    //     "eps": "Sura",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Griffin",
    //     "segundoNombre": "Briar",
    //     "primerApellido": "Conley",
    //     "segundoApellido": "Bird",
    //     "tipoID": "CC",
    //     "id": "2337332783",
    //     "fechaNacimiento": "05/01/2008",
    //     "email": "dolor@hotmail.org",
    //     "emailSecundario": "orci.ut.semper@hotmail.co",
    //     "telefono": 1246862433,
    //     "eps": "Sanitas",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Baxter",
    //     "segundoNombre": "Anjolie",
    //     "primerApellido": "Melendez",
    //     "segundoApellido": "Moreno",
    //     "tipoID": "CC",
    //     "id": "8678714995",
    //     "fechaNacimiento": "30/07/1946",
    //     "email": "quisque.ornare.tortor@google.edu",
    //     "emailSecundario": "nec@google.co",
    //     "telefono": 3115596416,
    //     "eps": "Sanitas",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Bell",
    //     "segundoNombre": "Thane",
    //     "primerApellido": "Lucas",
    //     "segundoApellido": "Prince",
    //     "tipoID": "CC",
    //     "id": "4040012822",
    //     "fechaNacimiento": "28/12/1962",
    //     "email": "aliquet@outlook.edu",
    //     "emailSecundario": "id@outlook.org",
    //     "telefono": 1797638209,
    //     "eps": "Compensar",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Kenyon",
    //     "segundoNombre": "Cameran",
    //     "primerApellido": "Fuentes",
    //     "segundoApellido": "Dawson",
    //     "tipoID": "CC",
    //     "id": "1270647892",
    //     "fechaNacimiento": "22/10/1959",
    //     "email": "nonummy.ut@google.comco",
    //     "emailSecundario": "senectus.et@yahoo.net",
    //     "telefono": 2678725134,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Tanisha",
    //     "segundoNombre": "Samantha",
    //     "primerApellido": "Vincent",
    //     "segundoApellido": "Johnson",
    //     "tipoID": "CC",
    //     "id": "6447456420",
    //     "fechaNacimiento": "18/02/1971",
    //     "email": "cursus.purus.nullam@google.org",
    //     "emailSecundario": "in.ornare@icloud.edu",
    //     "telefono": 3116112422,
    //     "eps": "Compensar",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Kaye",
    //     "segundoNombre": "Deborah",
    //     "primerApellido": "Hammond",
    //     "segundoApellido": "Webster",
    //     "tipoID": "CC",
    //     "id": "6379386447",
    //     "fechaNacimiento": "06/03/1992",
    //     "email": "ullamcorper@google.org",
    //     "emailSecundario": "amet.dapibus@outlook.co",
    //     "telefono": 2415624749,
    //     "eps": "Sura",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Amelia",
    //     "segundoNombre": "Germaine",
    //     "primerApellido": "Johns",
    //     "segundoApellido": "Conway",
    //     "tipoID": "CC",
    //     "id": "5304619778",
    //     "fechaNacimiento": "30/01/1960",
    //     "email": "turpis.non@hotmail.co",
    //     "emailSecundario": "mollis.nec@yahoo.com",
    //     "telefono": 5174424316,
    //     "eps": "Compensar",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Amal",
    //     "segundoNombre": "Lucas",
    //     "primerApellido": "Moran",
    //     "segundoApellido": "Mcfadden",
    //     "tipoID": "CC",
    //     "id": "6420147871",
    //     "fechaNacimiento": "03/09/1985",
    //     "email": "faucibus.orci@outlook.org",
    //     "emailSecundario": "eget.magna@yahoo.com",
    //     "telefono": 8843095120,
    //     "eps": "Compensar",
    //     "tipoSangre": "A-"
    //   },
    //   {
    //     "primerNombre": "Stephen",
    //     "segundoNombre": "Jolene",
    //     "primerApellido": "Kim",
    //     "segundoApellido": "Whitney",
    //     "tipoID": "CC",
    //     "id": "8328465021",
    //     "fechaNacimiento": "19/03/1944",
    //     "email": "lacus.cras@outlook.net",
    //     "emailSecundario": "neque.sed@yahoo.co",
    //     "telefono": 7738211843,
    //     "eps": "Sura",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Desirae",
    //     "segundoNombre": "Zorita",
    //     "primerApellido": "Tyler",
    //     "segundoApellido": "Hyde",
    //     "tipoID": "CC",
    //     "id": "4515024385",
    //     "fechaNacimiento": "27/03/1992",
    //     "email": "consectetuer.euismod@yahoo.comco",
    //     "emailSecundario": "egestas@hotmail.comco",
    //     "telefono": 2760896799,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Alexandra",
    //     "segundoNombre": "Hadassah",
    //     "primerApellido": "Taylor",
    //     "segundoApellido": "Cooley",
    //     "tipoID": "CC",
    //     "id": "8293623153",
    //     "fechaNacimiento": "23/05/1967",
    //     "email": "enim.sit@hotmail.com",
    //     "emailSecundario": "auctor.non@outlook.net",
    //     "telefono": 2568468068,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Jenette",
    //     "segundoNombre": "Zoe",
    //     "primerApellido": "Sparks",
    //     "segundoApellido": "Erickson",
    //     "tipoID": "CC",
    //     "id": "3827056178",
    //     "fechaNacimiento": "27/04/1980",
    //     "email": "est.arcu@hotmail.co",
    //     "emailSecundario": "mi@icloud.co",
    //     "telefono": 3656867986,
    //     "eps": "Compensar",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Jaime",
    //     "segundoNombre": "Patricia",
    //     "primerApellido": "William",
    //     "segundoApellido": "Christian",
    //     "tipoID": "CC",
    //     "id": "5250784444",
    //     "fechaNacimiento": "07/01/1979",
    //     "email": "nunc.ullamcorper@outlook.comco",
    //     "emailSecundario": "aliquam.auctor.velit@hotmail.co",
    //     "telefono": 4270746004,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Kenyon",
    //     "segundoNombre": "Keely",
    //     "primerApellido": "Sanchez",
    //     "segundoApellido": "Mcfarland",
    //     "tipoID": "CC",
    //     "id": "7721273086",
    //     "fechaNacimiento": "03/11/1954",
    //     "email": "eget@outlook.co",
    //     "emailSecundario": "aenean.massa@outlook.co",
    //     "telefono": 7167335038,
    //     "eps": "Sura",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Scott",
    //     "segundoNombre": "Sopoline",
    //     "primerApellido": "Tucker",
    //     "segundoApellido": "Reed",
    //     "tipoID": "CC",
    //     "id": "2346527787",
    //     "fechaNacimiento": "14/06/1946",
    //     "email": "etiam.ligula@icloud.org",
    //     "emailSecundario": "nisl.maecenas@outlook.org",
    //     "telefono": 3861159735,
    //     "eps": "Sura",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Renee",
    //     "segundoNombre": "Lilah",
    //     "primerApellido": "Silva",
    //     "segundoApellido": "Hogan",
    //     "tipoID": "CC",
    //     "id": "7689264736",
    //     "fechaNacimiento": "24/03/1932",
    //     "email": "erat.semper@google.co",
    //     "emailSecundario": "est.tempor@yahoo.co",
    //     "telefono": 7342691041,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Maile",
    //     "segundoNombre": "September",
    //     "primerApellido": "Harrison",
    //     "segundoApellido": "Lindsay",
    //     "tipoID": "CC",
    //     "id": "7772379290",
    //     "fechaNacimiento": "24/05/1946",
    //     "email": "quis.arcu@yahoo.com",
    //     "emailSecundario": "porttitor.interdum@hotmail.com",
    //     "telefono": 7743363238,
    //     "eps": "Compensar",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Azalia",
    //     "segundoNombre": "Hilda",
    //     "primerApellido": "Boyd",
    //     "segundoApellido": "Guzman",
    //     "tipoID": "CC",
    //     "id": "4481889513",
    //     "fechaNacimiento": "20/11/1983",
    //     "email": "elit.pellentesque.a@hotmail.edu",
    //     "emailSecundario": "mattis.semper@google.comco",
    //     "telefono": 7857444906,
    //     "eps": "Compensar",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Rahim",
    //     "segundoNombre": "Jada",
    //     "primerApellido": "Conley",
    //     "segundoApellido": "Keller",
    //     "tipoID": "CC",
    //     "id": "4580358802",
    //     "fechaNacimiento": "13/08/1981",
    //     "email": "luctus.ut@outlook.co",
    //     "emailSecundario": "nec.mauris@icloud.co",
    //     "telefono": 7849057775,
    //     "eps": "Sura",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Daria",
    //     "segundoNombre": "Martena",
    //     "primerApellido": "Stone",
    //     "segundoApellido": "Burke",
    //     "tipoID": "CC",
    //     "id": "7572391864",
    //     "fechaNacimiento": "19/11/1989",
    //     "email": "sollicitudin@icloud.net",
    //     "emailSecundario": "lorem.lorem@hotmail.com",
    //     "telefono": 9476592235,
    //     "eps": "Compensar",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Ulysses",
    //     "segundoNombre": "Nathaniel",
    //     "primerApellido": "Bowers",
    //     "segundoApellido": "Nelson",
    //     "tipoID": "CC",
    //     "id": "8378349607",
    //     "fechaNacimiento": "14/08/1995",
    //     "email": "dui.cras.pellentesque@hotmail.net",
    //     "emailSecundario": "primis.in.faucibus@google.com",
    //     "telefono": 5757714256,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Yoshio",
    //     "segundoNombre": "Teegan",
    //     "primerApellido": "Wynn",
    //     "segundoApellido": "Lucas",
    //     "tipoID": "CC",
    //     "id": "4232677355",
    //     "fechaNacimiento": "16/01/2008",
    //     "email": "et.magnis@outlook.org",
    //     "emailSecundario": "lobortis.mauris.suspendisse@icloud.org",
    //     "telefono": 2785376261,
    //     "eps": "Sura",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Vaughan",
    //     "segundoNombre": "Abigail",
    //     "primerApellido": "Sanders",
    //     "segundoApellido": "Willis",
    //     "tipoID": "CC",
    //     "id": "5613839173",
    //     "fechaNacimiento": "17/10/1932",
    //     "email": "ultrices.sit@icloud.org",
    //     "emailSecundario": "vehicula@yahoo.comco",
    //     "telefono": 5498873267,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Catherine",
    //     "segundoNombre": "Whitney",
    //     "primerApellido": "Simpson",
    //     "segundoApellido": "Monroe",
    //     "tipoID": "CC",
    //     "id": "8722376124",
    //     "fechaNacimiento": "22/03/1956",
    //     "email": "mus.proin@google.comco",
    //     "emailSecundario": "adipiscing.elit@icloud.org",
    //     "telefono": 7848282583,
    //     "eps": "Sanitas",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Xantha",
    //     "segundoNombre": "Stacey",
    //     "primerApellido": "Hart",
    //     "segundoApellido": "Bowman",
    //     "tipoID": "CC",
    //     "id": "5182649122",
    //     "fechaNacimiento": "12/02/1943",
    //     "email": "donec.nibh@google.org",
    //     "emailSecundario": "odio.a@hotmail.co",
    //     "telefono": 5631143753,
    //     "eps": "Compensar",
    //     "tipoSangre": "A-"
    //   },
    //   {
    //     "primerNombre": "Kane",
    //     "segundoNombre": "Dylan",
    //     "primerApellido": "Alford",
    //     "segundoApellido": "Wiggins",
    //     "tipoID": "CC",
    //     "id": "4618383681",
    //     "fechaNacimiento": "02/09/1934",
    //     "email": "interdum@google.co",
    //     "emailSecundario": "convallis.convallis.dolor@yahoo.comco",
    //     "telefono": 2823913182,
    //     "eps": "Sura",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Clio",
    //     "segundoNombre": "Halla",
    //     "primerApellido": "Nolan",
    //     "segundoApellido": "Christensen",
    //     "tipoID": "CC",
    //     "id": "5248882531",
    //     "fechaNacimiento": "16/11/1995",
    //     "email": "tristique.senectus.et@hotmail.net",
    //     "emailSecundario": "amet.risus@google.comco",
    //     "telefono": 3848547633,
    //     "eps": "Compensar",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Kaye",
    //     "segundoNombre": "Hilary",
    //     "primerApellido": "Barnett",
    //     "segundoApellido": "Reese",
    //     "tipoID": "CC",
    //     "id": "4625243949",
    //     "fechaNacimiento": "13/09/1933",
    //     "email": "maecenas.iaculis@outlook.org",
    //     "emailSecundario": "quisque.nonummy.ipsum@hotmail.net",
    //     "telefono": 9536841518,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Elliott",
    //     "segundoNombre": "Emily",
    //     "primerApellido": "Snow",
    //     "segundoApellido": "Dunn",
    //     "tipoID": "CC",
    //     "id": "8308353539",
    //     "fechaNacimiento": "03/01/1959",
    //     "email": "suspendisse.aliquet@outlook.comco",
    //     "emailSecundario": "parturient@icloud.org",
    //     "telefono": 5411188197,
    //     "eps": "Sura",
    //     "tipoSangre": "A-"
    //   },
    //   {
    //     "primerNombre": "Linus",
    //     "segundoNombre": "Iliana",
    //     "primerApellido": "Bean",
    //     "segundoApellido": "Briggs",
    //     "tipoID": "CC",
    //     "id": "8751874013",
    //     "fechaNacimiento": "23/12/1948",
    //     "email": "amet.luctus.vulputate@icloud.edu",
    //     "emailSecundario": "nullam@outlook.co",
    //     "telefono": 1521315897,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Alexander",
    //     "segundoNombre": "Carolyn",
    //     "primerApellido": "Harrington",
    //     "segundoApellido": "Gaines",
    //     "tipoID": "CC",
    //     "id": "5238927507",
    //     "fechaNacimiento": "25/08/1968",
    //     "email": "et.rutrum.non@google.edu",
    //     "emailSecundario": "vitae@yahoo.comco",
    //     "telefono": 3578857847,
    //     "eps": "Sura",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Sopoline",
    //     "segundoNombre": "Carl",
    //     "primerApellido": "Baker",
    //     "segundoApellido": "Pruitt",
    //     "tipoID": "CC",
    //     "id": "6737285209",
    //     "fechaNacimiento": "07/04/1967",
    //     "email": "mi.pede.nonummy@yahoo.co",
    //     "emailSecundario": "ligula.aenean@outlook.edu",
    //     "telefono": 3246742918,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Zephr",
    //     "segundoNombre": "Rae",
    //     "primerApellido": "Petty",
    //     "segundoApellido": "Ferrell",
    //     "tipoID": "CC",
    //     "id": "5096745782",
    //     "fechaNacimiento": "06/09/1978",
    //     "email": "consectetuer.adipiscing.elit@icloud.edu",
    //     "emailSecundario": "purus.maecenas@outlook.com",
    //     "telefono": 2416658581,
    //     "eps": "Sura",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Hyatt",
    //     "segundoNombre": "Nasim",
    //     "primerApellido": "Webb",
    //     "segundoApellido": "Ray",
    //     "tipoID": "CC",
    //     "id": "2269647756",
    //     "fechaNacimiento": "26/11/2006",
    //     "email": "nec.euismod.in@outlook.comco",
    //     "emailSecundario": "vel.faucibus.id@icloud.edu",
    //     "telefono": 7253492286,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Dahlia",
    //     "segundoNombre": "Noah",
    //     "primerApellido": "Hill",
    //     "segundoApellido": "Byers",
    //     "tipoID": "CC",
    //     "id": "7368273750",
    //     "fechaNacimiento": "11/03/1940",
    //     "email": "mauris.magna@icloud.co",
    //     "emailSecundario": "lorem.fringilla.ornare@google.edu",
    //     "telefono": 4842366148,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Malcolm",
    //     "segundoNombre": "Howard",
    //     "primerApellido": "Parks",
    //     "segundoApellido": "Delgado",
    //     "tipoID": "CC",
    //     "id": "4764853188",
    //     "fechaNacimiento": "17/08/1993",
    //     "email": "nibh.quisque.nonummy@yahoo.com",
    //     "emailSecundario": "mi.felis@icloud.comco",
    //     "telefono": 5314221964,
    //     "eps": "Sura",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Melissa",
    //     "segundoNombre": "Tamara",
    //     "primerApellido": "Kerr",
    //     "segundoApellido": "Kent",
    //     "tipoID": "CC",
    //     "id": "7558022394",
    //     "fechaNacimiento": "01/03/1965",
    //     "email": "iaculis.nec@icloud.com",
    //     "emailSecundario": "consectetuer.adipiscing@yahoo.net",
    //     "telefono": 4422588425,
    //     "eps": "Compensar",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Nicole",
    //     "segundoNombre": "Bethany",
    //     "primerApellido": "Brown",
    //     "segundoApellido": "Wong",
    //     "tipoID": "CC",
    //     "id": "4881440277",
    //     "fechaNacimiento": "07/12/1996",
    //     "email": "donec@hotmail.net",
    //     "emailSecundario": "adipiscing.enim@yahoo.com",
    //     "telefono": 8902405211,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Randall",
    //     "segundoNombre": "Glenna",
    //     "primerApellido": "Rowe",
    //     "segundoApellido": "Moody",
    //     "tipoID": "CC",
    //     "id": "8069123848",
    //     "fechaNacimiento": "02/10/2008",
    //     "email": "proin@yahoo.edu",
    //     "emailSecundario": "ante.iaculis@icloud.edu",
    //     "telefono": 4751648871,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB+"
    //   },
    //   {
    //     "primerNombre": "Maisie",
    //     "segundoNombre": "Genevieve",
    //     "primerApellido": "Ewing",
    //     "segundoApellido": "Richardson",
    //     "tipoID": "CC",
    //     "id": "1472741533",
    //     "fechaNacimiento": "15/01/1986",
    //     "email": "quis@hotmail.edu",
    //     "emailSecundario": "ut.odio.vel@icloud.org",
    //     "telefono": 2711840417,
    //     "eps": "Sura",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Kennedy",
    //     "segundoNombre": "Norman",
    //     "primerApellido": "Brewer",
    //     "segundoApellido": "O'brien",
    //     "tipoID": "CC",
    //     "id": "5495680913",
    //     "fechaNacimiento": "04/01/1990",
    //     "email": "quis@hotmail.net",
    //     "emailSecundario": "donec@icloud.comco",
    //     "telefono": 6722365522,
    //     "eps": "Sura",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Akeem",
    //     "segundoNombre": "Winifred",
    //     "primerApellido": "Haley",
    //     "segundoApellido": "Boone",
    //     "tipoID": "CC",
    //     "id": "5666518585",
    //     "fechaNacimiento": "26/08/1962",
    //     "email": "in.faucibus.orci@outlook.comco",
    //     "emailSecundario": "nec@yahoo.co",
    //     "telefono": 7564893251,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Christine",
    //     "segundoNombre": "Tasha",
    //     "primerApellido": "Porter",
    //     "segundoApellido": "Hampton",
    //     "tipoID": "CC",
    //     "id": "2634693010",
    //     "fechaNacimiento": "23/12/1934",
    //     "email": "adipiscing@hotmail.org",
    //     "emailSecundario": "vel.quam@google.comco",
    //     "telefono": 7967384737,
    //     "eps": "Compensar",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Destiny",
    //     "segundoNombre": "Vera",
    //     "primerApellido": "Mullen",
    //     "segundoApellido": "Ferguson",
    //     "tipoID": "CC",
    //     "id": "2883550457",
    //     "fechaNacimiento": "11/11/1969",
    //     "email": "gravida.sagittis@outlook.edu",
    //     "emailSecundario": "iaculis.nec@google.comco",
    //     "telefono": 2528971796,
    //     "eps": "Compensar",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Octavius",
    //     "segundoNombre": "Lawrence",
    //     "primerApellido": "Simmons",
    //     "segundoApellido": "Hammond",
    //     "tipoID": "CC",
    //     "id": "2235258442",
    //     "fechaNacimiento": "18/05/1946",
    //     "email": "suspendisse.non.leo@outlook.com",
    //     "emailSecundario": "dui.cum@hotmail.comco",
    //     "telefono": 8423521739,
    //     "eps": "Sanitas",
    //     "tipoSangre": "A-"
    //   },
    //   {
    //     "primerNombre": "Rahim",
    //     "segundoNombre": "Quinlan",
    //     "primerApellido": "Poole",
    //     "segundoApellido": "Dickson",
    //     "tipoID": "CC",
    //     "id": "6197602158",
    //     "fechaNacimiento": "27/06/1981",
    //     "email": "vestibulum.mauris.magna@yahoo.org",
    //     "emailSecundario": "at.libero@outlook.net",
    //     "telefono": 1233035337,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Sean",
    //     "segundoNombre": "Garrison",
    //     "primerApellido": "Holland",
    //     "segundoApellido": "Porter",
    //     "tipoID": "CC",
    //     "id": "5051744985",
    //     "fechaNacimiento": "27/08/1931",
    //     "email": "aliquam.eros.turpis@yahoo.net",
    //     "emailSecundario": "torquent.per.conubia@icloud.com",
    //     "telefono": 3144545389,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB+"
    //   },
    //   {
    //     "primerNombre": "Jonah",
    //     "segundoNombre": "Cameron",
    //     "primerApellido": "Byrd",
    //     "segundoApellido": "Baker",
    //     "tipoID": "CC",
    //     "id": "3850220081",
    //     "fechaNacimiento": "01/04/1950",
    //     "email": "per.conubia@google.edu",
    //     "emailSecundario": "aliquet.odio@yahoo.co",
    //     "telefono": 7880433865,
    //     "eps": "Sura",
    //     "tipoSangre": "AB+"
    //   },
    //   {
    //     "primerNombre": "Alden",
    //     "segundoNombre": "Caryn",
    //     "primerApellido": "Adkins",
    //     "segundoApellido": "Wilkinson",
    //     "tipoID": "CC",
    //     "id": "7738313462",
    //     "fechaNacimiento": "27/03/1989",
    //     "email": "vitae@icloud.co",
    //     "emailSecundario": "venenatis.vel.faucibus@outlook.net",
    //     "telefono": 9138830346,
    //     "eps": "Compensar",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Cruz",
    //     "segundoNombre": "Gage",
    //     "primerApellido": "Richardson",
    //     "segundoApellido": "Zimmerman",
    //     "tipoID": "CC",
    //     "id": "2722729926",
    //     "fechaNacimiento": "27/02/1931",
    //     "email": "nulla.cras@icloud.com",
    //     "emailSecundario": "diam@hotmail.edu",
    //     "telefono": 8781466312,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Bert",
    //     "segundoNombre": "Shellie",
    //     "primerApellido": "Dixon",
    //     "segundoApellido": "Nelson",
    //     "tipoID": "CC",
    //     "id": "4253329047",
    //     "fechaNacimiento": "12/10/2009",
    //     "email": "cras.dolor@icloud.com",
    //     "emailSecundario": "feugiat@yahoo.org",
    //     "telefono": 8788358369,
    //     "eps": "Sura",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Talon",
    //     "segundoNombre": "Anastasia",
    //     "primerApellido": "Crawford",
    //     "segundoApellido": "Burris",
    //     "tipoID": "CC",
    //     "id": "8871344269",
    //     "fechaNacimiento": "17/08/1958",
    //     "email": "ultricies@outlook.edu",
    //     "emailSecundario": "nulla.interdum@icloud.comco",
    //     "telefono": 2135048325,
    //     "eps": "Compensar",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Kirby",
    //     "segundoNombre": "Erasmus",
    //     "primerApellido": "Strickland",
    //     "segundoApellido": "Estrada",
    //     "tipoID": "CC",
    //     "id": "6957037352",
    //     "fechaNacimiento": "23/04/1976",
    //     "email": "magna@icloud.net",
    //     "emailSecundario": "parturient@hotmail.edu",
    //     "telefono": 6378118528,
    //     "eps": "Sura",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Chaim",
    //     "segundoNombre": "Ramona",
    //     "primerApellido": "Herring",
    //     "segundoApellido": "Simon",
    //     "tipoID": "CC",
    //     "id": "2492495855",
    //     "fechaNacimiento": "19/08/1940",
    //     "email": "cursus.a@icloud.co",
    //     "emailSecundario": "amet.consectetuer@hotmail.org",
    //     "telefono": 1362056296,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Marcia",
    //     "segundoNombre": "Rogan",
    //     "primerApellido": "Buckner",
    //     "segundoApellido": "Hernandez",
    //     "tipoID": "CC",
    //     "id": "4458717024",
    //     "fechaNacimiento": "05/09/1977",
    //     "email": "ultricies@yahoo.com",
    //     "emailSecundario": "purus@icloud.org",
    //     "telefono": 6056431876,
    //     "eps": "Sura",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Ria",
    //     "segundoNombre": "Boris",
    //     "primerApellido": "Fleming",
    //     "segundoApellido": "Hanson",
    //     "tipoID": "CC",
    //     "id": "8246896482",
    //     "fechaNacimiento": "25/06/1994",
    //     "email": "iaculis.lacus@icloud.comco",
    //     "emailSecundario": "lectus.pede@icloud.com",
    //     "telefono": 4967782493,
    //     "eps": "Compensar",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Skyler",
    //     "segundoNombre": "Keane",
    //     "primerApellido": "Koch",
    //     "segundoApellido": "Nguyen",
    //     "tipoID": "CC",
    //     "id": "4465577702",
    //     "fechaNacimiento": "23/06/1978",
    //     "email": "erat.in@google.net",
    //     "emailSecundario": "magna.duis@google.comco",
    //     "telefono": 2473354052,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Belle",
    //     "segundoNombre": "Cassidy",
    //     "primerApellido": "Garner",
    //     "segundoApellido": "Mcknight",
    //     "tipoID": "CC",
    //     "id": "2632669354",
    //     "fechaNacimiento": "30/03/1988",
    //     "email": "magna.a.neque@hotmail.org",
    //     "emailSecundario": "dignissim.lacus@google.edu",
    //     "telefono": 9148324771,
    //     "eps": "Sura",
    //     "tipoSangre": "A-"
    //   },
    //   {
    //     "primerNombre": "Zelenia",
    //     "segundoNombre": "Ingrid",
    //     "primerApellido": "Knox",
    //     "segundoApellido": "Higgins",
    //     "tipoID": "CC",
    //     "id": "8137460353",
    //     "fechaNacimiento": "08/11/1934",
    //     "email": "libero.proin@yahoo.org",
    //     "emailSecundario": "ornare.lectus.justo@hotmail.co",
    //     "telefono": 5946848275,
    //     "eps": "Compensar",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Carissa",
    //     "segundoNombre": "Nero",
    //     "primerApellido": "Kaufman",
    //     "segundoApellido": "Lopez",
    //     "tipoID": "CC",
    //     "id": "9997632021",
    //     "fechaNacimiento": "13/09/2003",
    //     "email": "in.ornare@hotmail.net",
    //     "emailSecundario": "elit.etiam@outlook.edu",
    //     "telefono": 3342534749,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Rhiannon",
    //     "segundoNombre": "Mark",
    //     "primerApellido": "Perry",
    //     "segundoApellido": "Bailey",
    //     "tipoID": "CC",
    //     "id": "5167547841",
    //     "fechaNacimiento": "09/03/1983",
    //     "email": "non.hendrerit@yahoo.net",
    //     "emailSecundario": "adipiscing.mauris.molestie@icloud.comco",
    //     "telefono": 6170898151,
    //     "eps": "Sanitas",
    //     "tipoSangre": "O-"
    //   },
    //   {
    //     "primerNombre": "Seth",
    //     "segundoNombre": "Lyle",
    //     "primerApellido": "Cook",
    //     "segundoApellido": "Hayden",
    //     "tipoID": "CC",
    //     "id": "8775318537",
    //     "fechaNacimiento": "18/02/1934",
    //     "email": "aliquam.eu@yahoo.comco",
    //     "emailSecundario": "suspendisse.aliquet.molestie@google.com",
    //     "telefono": 8757369051,
    //     "eps": "Sanitas",
    //     "tipoSangre": "B-"
    //   },
    //   {
    //     "primerNombre": "Astra",
    //     "segundoNombre": "Cooper",
    //     "primerApellido": "Cline",
    //     "segundoApellido": "Nicholson",
    //     "tipoID": "CC",
    //     "id": "8522865648",
    //     "fechaNacimiento": "06/07/1964",
    //     "email": "duis@hotmail.org",
    //     "emailSecundario": "arcu.sed.et@hotmail.org",
    //     "telefono": 9435104114,
    //     "eps": "Sura",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Noelle",
    //     "segundoNombre": "Tatum",
    //     "primerApellido": "Fleming",
    //     "segundoApellido": "Dejesus",
    //     "tipoID": "CC",
    //     "id": "6819438474",
    //     "fechaNacimiento": "01/10/1965",
    //     "email": "etiam.imperdiet.dictum@yahoo.com",
    //     "emailSecundario": "ante.blandit.viverra@hotmail.edu",
    //     "telefono": 4584560104,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB-"
    //   },
    //   {
    //     "primerNombre": "Maggie",
    //     "segundoNombre": "Garrison",
    //     "primerApellido": "Martin",
    //     "segundoApellido": "Caldwell",
    //     "tipoID": "CC",
    //     "id": "5973796591",
    //     "fechaNacimiento": "07/09/1986",
    //     "email": "integer.mollis@google.co",
    //     "emailSecundario": "donec.tincidunt@hotmail.org",
    //     "telefono": 6741793719,
    //     "eps": "Compensar",
    //     "tipoSangre": "B+"
    //   },
    //   {
    //     "primerNombre": "Kyla",
    //     "segundoNombre": "Germane",
    //     "primerApellido": "Weiss",
    //     "segundoApellido": "Perez",
    //     "tipoID": "CC",
    //     "id": "5134755692",
    //     "fechaNacimiento": "20/09/1933",
    //     "email": "at.augue@outlook.org",
    //     "emailSecundario": "gravida.molestie.arcu@google.net",
    //     "telefono": 1695493682,
    //     "eps": "Sanitas",
    //     "tipoSangre": "A+"
    //   },
    //   {
    //     "primerNombre": "Nina",
    //     "segundoNombre": "Austin",
    //     "primerApellido": "Harper",
    //     "segundoApellido": "Jimenez",
    //     "tipoID": "CC",
    //     "id": "9774733266",
    //     "fechaNacimiento": "12/04/1969",
    //     "email": "tellus.suspendisse.sed@yahoo.com",
    //     "emailSecundario": "vitae.erat@yahoo.comco",
    //     "telefono": 4439642950,
    //     "eps": "Sura",
    //     "tipoSangre": "O+"
    //   },
    //   {
    //     "primerNombre": "Brielle",
    //     "segundoNombre": "Derek",
    //     "primerApellido": "Dean",
    //     "segundoApellido": "Winters",
    //     "tipoID": "CC",
    //     "id": "3812738081",
    //     "fechaNacimiento": "04/10/1944",
    //     "email": "erat.in.consectetuer@google.org",
    //     "emailSecundario": "malesuada.malesuada.integer@yahoo.net",
    //     "telefono": 7092711873,
    //     "eps": "Sanitas",
    //     "tipoSangre": "AB+"
    //   },
    //   {
    //     "primerNombre": "Astra",
    //     "segundoNombre": "Cherokee",
    //     "primerApellido": "Rocha",
    //     "segundoApellido": "Diaz",
    //     "tipoID": "CC",
    //     "id": "9886257621",
    //     "fechaNacimiento": "15/06/1973",
    //     "email": "juan@gmai.com",
    //     "emailSecundario": "vel.venenatis@google.edu",
    //     "telefono": 9957925631,
    //     "eps": "Sura",
    //     "tipoSangre": "AB+",
    //     propiedades: {
    //       '564782345-9': {
    //         roles: [
    //         ],
    //         up: [
    //           {
    //             up: 'E1T1A103',
    //             nombre: 'Torre 1-Apartamento 103',
    //             roles: [
    //               { nombre: 'propietario' }
    //             ]
    //           }
    //         ]
    //       }
    //     },
    //   },
    //   {
    //     "primerNombre": "Kane",
    //     "segundoNombre": "Kennedy",
    //     "primerApellido": "Graham",
    //     "segundoApellido": "Meadows",
    //     "tipoID": "CC",
    //     "id": "6962587149",
    //     "fechaNacimiento": "11/05/1961",
    //     "email": "vel.arcu@icloud.comco",
    //     "emailSecundario": "dolor.quisque.tincidunt@outlook.co",
    //     "telefono": 4722031651,
    //     "eps": "Sura",
    //     "tipoSangre": "A+",
    //     propiedades: {
    //       '564782345-9': {
    //         roles: [
    //         ],
    //         up: [
    //           {
    //             up: 'E1T1A101',
    //             nombre: 'Torre 1-Apartamento 101',
    //             roles: [
    //               { nombre: 'propietario' }
    //             ]
    //           },
    //           {
    //             up: 'E1T1A102',
    //             nombre: 'Torre 1-Apartamento 102',
    //             roles: [
    //               { nombre: 'propietario' }
    //             ]
    //           }
    //         ]
    //       }
    //     },
    //   }
    // ]

    // let global = {
    //   bp: {
    //     0: {
    //       abr: 'A',
    //       icon: 'house',
    //       id: 0,
    //       nombre: 'Apartamento',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'altura',
    //           title: 'Altura(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'areaPrivada',
    //           title: 'Area Privada(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'areaConstruida',
    //           title: 'Area Total(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'banos',
    //           title: '# de Baños',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'habitaciones',
    //           title: '# de Habitaciones',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'coeficiente',
    //           title: 'Coeficiente',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },
    //     1: {
    //       abr: 'O',
    //       icon: 'house',
    //       id: 1,
    //       nombre: 'Oficina',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'altura',
    //           title: 'Altura(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'areaPrivada',
    //           title: 'Area Privada(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'areaConstruida',
    //           title: 'Area Total(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'banos',
    //           title: '# de Baños',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'habitaciones',
    //           title: '# de Habitaciones',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'coeficiente',
    //           title: 'Coeficiente',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },
    //     2: {
    //       abr: 'L',
    //       icon: 'house',
    //       id: 2,
    //       nombre: 'Local Comercial',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'altura',
    //           title: 'Altura(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'areaPrivada',
    //           title: 'Area Privada(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'areaConstruida',
    //           title: 'Area Total(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'banos',
    //           title: '# de Baños',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'habitaciones',
    //           title: '# de Habitaciones',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'coeficiente',
    //           title: 'Coeficiente',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },
    //     3: {
    //       abr: 'C',
    //       icon: 'house',
    //       id: 3,
    //       nombre: 'Casa',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'altura',
    //           title: 'Altura(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'areaPrivada',
    //           title: 'Area Privada(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'areaConstruida',
    //           title: 'Area Total(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'pisos',
    //           title: 'Pisos',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'banos',
    //           title: '# de Baños',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'habitaciones',
    //           title: '# de Habitaciones',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'coeficiente',
    //           title: 'Coeficiente',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },
    //     4: {
    //       abr: 'P',
    //       icon: 'house',
    //       id: 4,
    //       nombre: 'Parqueadero',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'areaConstruida',
    //           title: 'Area Total(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'coeficiente',
    //           title: 'Coeficiente',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },
    //     5: {
    //       abr: 'D',
    //       icon: 'house',
    //       id: 5,
    //       nombre: 'Deposito',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'areaConstruida',
    //           title: 'Area Total(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'coeficiente',
    //           title: 'Coeficiente',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     }
    //   },
    //   ua: {
    //     0: {
    //       abr: 'T',
    //       icon: 'edit',
    //       id: 0,
    //       nombre: 'Torre'
    //     },
    //     1: {
    //       abr: 'I',
    //       icon: 'edit',
    //       id: 1,
    //       nombre: 'Interior'
    //     },
    //     2: {
    //       abr: 'U',
    //       icon: 'edit',
    //       id: 2,
    //       nombre: 'Unidad'
    //     },
    //     3: {
    //       abr: 'M',
    //       icon: 'edit',
    //       id: 3,
    //       nombre: 'Manzana'
    //     },
    //     4: {
    //       abr: 'S',
    //       icon: 'edit',
    //       id: 4,
    //       nombre: 'Sector'
    //     },
    //     5: {
    //       abr: 'E',
    //       icon: 'edit',
    //       id: 5,
    //       nombre: 'Etapa'
    //     }
    //   },
    //   bc: {
    //     0: {
    //       abr: 'PIS',
    //       icon: 'house',
    //       id: 0,
    //       nombre: 'Piscina',
    //       titulo: 'Piscina',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'volumen',
    //           title: 'Volume(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //         {
    //           nombre: 'area',
    //           title: 'Area',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },
    //     1: {
    //       abr: 'JAC',
    //       icon: 'house',
    //       id: 1,
    //       nombre: 'Jacuzzi',
    //       titulo: 'Jacuzzi',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'volumen',
    //           title: 'Volume(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },

    //     2: {
    //       abr: 'BBQ',
    //       icon: 'house',
    //       id: 2,
    //       nombre: 'BBQ',
    //       titulo: 'BBQ',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'volumen',
    //           title: 'Volume(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },

    //     3: {
    //       abr: 'TEN',
    //       icon: 'house',
    //       id: 3,
    //       nombre: 'Cancha_Tennis',
    //       titulo:'Cancha de Tennis',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'volumen',
    //           title: 'Volume(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },

    //     4: {
    //       abr: 'PAR',
    //       icon: 'house',
    //       id: 4,
    //       nombre: 'Parque_Ninos',
    //       titulo: 'Parque Infantil',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'volumen',
    //           title: 'Volume(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },
    //     5: {
    //       abr: 'PAV',
    //       icon: 'house',
    //       id: 5,
    //       nombre: 'Parqueadero_Visitantes',
    //       titulo: 'Parqueadero de Visitantes',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'area',
    //           title: 'Area(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },
    //     6: {
    //       abr: 'BIC',
    //       icon: 'house',
    //       id: 6,
    //       nombre: 'Bicicletero',
    //       titulo: 'Bicicletero',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'area',
    //           title: 'Area(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },
    //     7: {
    //       abr: 'ASC',
    //       icon: 'house',
    //       id: 7,
    //       nombre: 'Ascensor',
    //       titulo: 'Ascensor',
    //       campos: [
    //         {
    //           nombre: 'nombre',
    //           title: 'Nombre',
    //           len: 4,
    //           type: 'text',
    //         },
    //         {
    //           nombre: 'volumen',
    //           title: 'Volume(m²)',
    //           len: 4,
    //           type: 'number',
    //         },
    //       ]
    //     },
    //   }
    // }
    // let local = {
    //   avance: {
    //     uPrivadas: 100,
    //     bcExclusivos: 100,
    //     bcGeneral: 1000,
    //     bcEsenciales: 100,
    //     bcSectorizados: 100,
    //     bcParticular: 100
    //   },
    //   bp: {
    //     0: {
    //       abr: 'Apto',
    //       color: '#8778f7',
    //       icon: 'house',
    //       id: 0,
    //       nombre: 'Apartamento'
    //     },
    //     3: {
    //       abr: 'C',
    //       color: '#8778f7',
    //       icon: 'house',
    //       id: 3,
    //       nombre: 'Casa'
    //     },
    //     4: {
    //       abr: 'P',
    //       color: '#8778f7',
    //       icon: 'house',
    //       id: 4,
    //       nombre: 'Parqueadero'
    //     },
    //     5: {
    //       abr: 'Dep',
    //       color: '#8778f7',
    //       icon: 'house',
    //       id: 5,
    //       nombre: 'Deposito'
    //     }
    //   },
    //   ua: {
    //     0: {
    //       abr: 'T',
    //       color: '#8778f7',
    //       icon: 'edit',
    //       id: 0,
    //       nombre: 'Torre'
    //     },
    //     3: {
    //       abr: 'M',
    //       color: '#8778f7',
    //       icon: 'edit',
    //       id: 3,
    //       nombre: 'Manzana'
    //     },
    //     4: {
    //       abr: 'S',
    //       color: '#8778f7',
    //       icon: 'edit',
    //       id: 4,
    //       nombre: 'Sector'
    //     },
    //     5: {
    //       abr: 'Etapa',
    //       color: '#8778f7',
    //       icon: 'edit',
    //       id: 5,
    //       nombre: 'Etapa'
    //     }
    //   }
    // }
    // let estructura = {
    //   'E1': {
    //     esHoja: false,
    //     nivel: 0,
    //     id: 1,
    //     nombreBase: 'Etapa 1',
    //     nombre: 'Etapa 1',
    //     nombrePadre: null,
    //     padre: null,
    //     tipo: 5,
    //     tipoNombre: 'Etapa',
    //     subunidades: true,
    //   },
    //   'E2': {
    //     esHoja: false,
    //     nivel: 0,
    //     id: 2,
    //     nombreBase: 'Etapa 2',
    //     nombre: 'Etapa 2',
    //     nombrePadre: null,
    //     padre: null,
    //     tipo: 5,
    //     tipoNombre: 'Etapa',
    //     subunidades: true,
    //   },
    //   'E1T1': {
    //     esHoja: true,
    //     nivel: 1,
    //     id: 1,
    //     nombreBase: 'Torre 1',
    //     nombre: 'Etapa 1-Torre 1',
    //     nombrePadre: 'Etapa 1',
    //     padre: 'E1',
    //     tipo: 0,
    //     tipoNombre: 'Torre'
    //   },
    //   'E1T2': {
    //     esHoja: true,
    //     nivel: 1,
    //     id: 2,
    //     nombreBase: 'Torre 2',
    //     nombre: 'Etapa 1-Torre 2',
    //     nombrePadre: 'Etapa 1',
    //     padre: 'E1',
    //     tipo: 0,
    //     tipoNombre: 'Torre'
    //   },
    //   'E1T3': {
    //     esHoja: true,
    //     nivel: 1,
    //     id: 3,
    //     nombreBase: 'Torre 3',
    //     nombre: 'Etapa 1-Torre 3',
    //     nombrePadre: 'Etapa 1',
    //     padre: 'E1',
    //     tipo: 0,
    //     tipoNombre: 'Torre'
    //   },
    //   'E1T4': {
    //     esHoja: true,
    //     nivel: 1,
    //     id: 4,
    //     nombreBase: 'Torre 4',
    //     nombre: 'Etapa 1-Torre 4',
    //     nombrePadre: 'Etapa 1',
    //     padre: 'E1',
    //     tipo: 0,
    //     tipoNombre: 'Torre'
    //   },
    //   'E2M1': {
    //     esHoja: true,
    //     nivel: 1,
    //     id: 1,
    //     nombreBase: 'Manzana 1',
    //     nombre: 'Etapa 2-Manzana 1',
    //     nombrePadre: 'Etapa 2',
    //     padre: 'E2',
    //     tipo: 3,
    //     tipoNombre: 'Manzana'
    //   },
    //   'E2M2': {
    //     esHoja: true,
    //     nivel: 1,
    //     id: 2,
    //     nombreBase: 'Manzana 2',
    //     nombre: 'Etapa 2-Manzana 2',
    //     nombrePadre: 'Etapa 2',
    //     padre: 'E2',
    //     tipo: 3,
    //     tipoNombre: 'Manzana'
    //   },
    //   'S1': {
    //     esHoja: true,
    //     nivel: 0,
    //     id: 1,
    //     nombreBase: 'Sector 1',
    //     nombre: 'Sector 1',
    //     nombrePadre: null,
    //     padre: null,
    //     tipo: 4,
    //     tipoNombre: 'Sector'
    //   },
    //   'S2': {
    //     esHoja: true,
    //     nivel: 0,
    //     id: 2,
    //     nombreBase: 'Sector 2',
    //     nombre: 'Sector 2',
    //     nombrePadre: null,
    //     padre: null,
    //     tipo: 4,
    //     tipoNombre: 'Sector'
    //   },
    //   'S3': {
    //     esHoja: true,
    //     nivel: 0,
    //     id: 3,
    //     nombreBase: 'Sector 3',
    //     nombre: 'Sector 3',
    //     nombrePadre: null,
    //     padre: null,
    //     tipo: 4,
    //     tipoNombre: 'Sector'
    //   }
    // }
    // let tiposBP = {
    //   'Apartamento_A': {
    //     nombre: 'Apartamento A',
    //     habitaciones: 2,
    //     areaConstruida: 80,
    //     areaPrivada: 64,
    //     banos: 2,
    //     bp: 0,
    //     bpNombre: 'Apartamento',
    //     coeficiente: 0.6877,
    //   },
    //   'Apartamento_B': {
    //     nombre: 'Apartamento B',
    //     habitaciones: 3,
    //     areaConstruida: 78,
    //     areaPrivada: 68,
    //     banos: 2,
    //     bp: 0,
    //     bpNombre: 'Apartamento',
    //     coeficiente: 0.6056,
    //   },
    //   'Casa_A': {
    //     nombre: 'Casa A',
    //     habitaciones: 3,
    //     areaConstruida: 80,
    //     areaPrivada: 70,
    //     banos: 2,
    //     pisos: 2,
    //     bp: 3,
    //     bpNombre: 'Casa',
    //     coeficiente: 0.6877,
    //   },
    //   'Casa_B': {
    //     nombre: 'Casa B',
    //     habitaciones: 4,
    //     areaConstruida: 100,
    //     areaPrivada: 90,
    //     banos: 3,
    //     pisos: 3,
    //     bp: 3,
    //     bpNombre: 'Casa',
    //     coeficiente: 0.859697,
    //   },
    //   'Parqueadero_Sencillo': {
    //     nombre: 'Parqueadero Sencillo',
    //     areaConstruida: 12,
    //     bp: 4,
    //     bpNombre: 'Parqueadero',
    //     coeficiente: 0.103,
    //   },
    //   'Parqueadero_Doble': {
    //     nombre: 'Parqueadero Doble',
    //     areaConstruida: 24,
    //     bp: 4,
    //     bpNombre: 'Parqueadero',
    //     coeficiente: 0.206,
    //   },
    //   'Deposito': {
    //     nombre: 'Deposito',
    //     areaConstruida: 4,
    //     bp: 5,
    //     bpNombre: 'Deposito',
    //     coeficiente: 0.03438,
    //   }
    // }
    // let bp = {

    // }
    // let idP = 1;
    // let idB = 1;
    // for (let i = 1; i < 5; i++) {//torre
    //   for (let j = 1; j < 5; j++) {//apto
    //     for (let k = 2; k < 6; k++) {//piso
    //       bp[`E1T${i}A${k}0${j}`] = {
    //         id: `${k}0${j}`,
    //         bp: 0,
    //         bpNombre: 'Apartamento',
    //         coeficiente: 0.6877,
    //         tipoBP: 'Apartamento_A',
    //         escritura: true,
    //         ua: `E1T${i}`,
    //         uaNombre:estructura[ `E1T${i}`].nombre,
    //         piso: k
    //       }
    //     }
    //     bp[`E1T${i}A10${j}`] = {
    //       id: `10${j}`,
    //       bp: 0,
    //       bpNombre: 'Apartamento',
    //       coeficiente: 0.6056,
    //       tipoBP: 'Apartamento_B',
    //       escritura: true,
    //       ua: `E1T${i}`,
    //         uaNombre:estructura[ `E1T${i}`].nombre,
    //       piso: 1
    //     }
    //   }
    //   for (let j = idP + 0; j < idP + 10; j++) {
    //     bp[`E1T${i}P${j}`] = {
    //       id: j,
    //       bp: 4,
    //       bpNombre: 'Parqueadero',
    //       coeficiente: 0.103,
    //       tipoBP: 'Parqueadero_Sencillo',
    //       escritura: false,
    //       ua: `E1T${i}`,
    //         uaNombre:estructura[ `E1T${i}`].nombre,
    //     }
    //   }
    //   idP = idP + 10;

    //   for (let j = idP + 0; j < idP + 10; j++) {
    //     bp[`E1T${i}P${j}`] = {
    //       id: j,
    //       bp: 4,
    //       bpNombre: 'Parqueadero',
    //       coeficiente: 0.206,
    //       tipoBP: 'Parqueadero_Doble',
    //       escritura: false,
    //       ua: `E1T${i}`,
    //         uaNombre:estructura[ `E1T${i}`].nombre,
    //     }
    //   }
    //   idP = idP + 10;
    //   for (let j = idB + 0; j < idB + 20; j++) {
    //     bp[`E1T${i}D${j}`] = {
    //       id: j,
    //       bp: 5,
    //       bpNombre: 'Deposito',
    //       coeficiente: 0.03438,
    //       tipoBP: 'Deposito',
    //       escritura: false,
    //       ua: `E1T${i}`,
    //         uaNombre:estructura[ `E1T${i}`].nombre,
    //     }
    //   }
    //   idB = idB + 20;
    // }

    // for (let i = 1; i < 13; i++) {
    //   bp[`E2M1D${i}`] = {
    //     id: i,
    //     bp: 3,
    //     bpNombre: 'Casa',
    //     coeficiente: 0.6877,
    //     tipoBP: 'Casa_A',
    //     escritura: true,
    //     ua: `E2M1`,
    //         uaNombre:estructura[ `E2M1`].nombre,
    //   }
    // }
    // for (let i = 13; i < 28; i++) {
    //   bp[`E2M2D${i}`] = {
    //     id: i,
    //     bp: 3,
    //     bpNombre: 'Casa',
    //     coeficiente: 0.859697,
    //     tipoBP: 'Casa_B',
    //     escritura: true,
    //     ua: `E2M2`,
    //         uaNombre:estructura[ `E2M2`].nombre,
    //   }
    // }
    // for (let j = idP + 0; j < idP + 23; j++) {
    //   bp[`S1P${j}`] = {
    //     id: j,
    //     bp: 4,
    //     bpNombre: 'Parqueadero',
    //     coeficiente: 0.103,
    //     tipoBP: 'Parqueadero_Sencillo',
    //     escritura: false,
    //     ua: `S1`,
    //         uaNombre:estructura[ `S1`].nombre,
    //   }
    // }
    // idP = idP + 23;
    // for (let j = idP + 0; j < idP + 24; j++) {
    //   bp[`S2P${j}`] = {
    //     id: j,
    //     bp: 4,
    //     bpNombre: 'Parqueadero',
    //     coeficiente: 0.103,
    //     tipoBP: 'Parqueadero_Sencillo',
    //     escritura: false,
    //     ua: `S2`,
    //         uaNombre:estructura[ `S2`].nombre,
    //   }
    // }
    // idP = idP + 24;
    // for (let j = idP + 0; j < idP + 40; j++) {
    //   bp[`S3P${j}`] = {
    //     id: j,
    //     bp: 4,
    //     bpNombre: 'Parqueadero',
    //     coeficiente: 0.103,
    //     tipoBP: 'Parqueadero_Sencillo',
    //     escritura: false,
    //     ua: `S3`,
    //         uaNombre:estructura[ `S3`].nombre,
    //   }
    // }
    // idP = idP + 40;

    // let up: any = {}
    // let clienteId = 0
    // Object.keys(bp).filter((k: any) => bp[k].bp == 0).forEach((key: any, i) => {
    //   let apto = bp[key];
    //   let kpar: any = Object.keys(bp).filter((k: any) => bp[k].bp == 4 && bp[k].ua == apto.ua && !bp[k].up)[0]
    //   let koutpar: any = Object.keys(bp).filter((k: any) => bp[k].bp == 4 && bp[k].ua == `S3` && !bp[k].up)[0]
    //   let kdep: any = Object.keys(bp).filter((k: any) => bp[k].bp == 5 && bp[k].ua == apto.ua && !bp[k].up)[0]
    //   up[key] = {
    //     nombre: `${apto.bpNombre} ${apto.id}`,
    //     propietario: `CC${users[clienteId].id}`,
    //     nombrePropietario: `${users[clienteId].primerNombre} ${users[clienteId].primerApellido}`,
    //     ua: apto.ua,
    //     uaNombre: estructura[apto.ua].nombre,
    //     bp: [
    //       {
    //         id: key,
    //         nombre: `${apto.bpNombre} ${apto.id}`,
    //         ua:apto.ua,
    //         uaNombre: apto.uaNombre,
    //         tipo: apto.bp
    //       }
    //     ],
    //     coeficiente: apto.coeficiente
    //   }
    //   users[clienteId].propiedades = {
    //     '564782345-9': {
    //       roles: [
    //       ],
    //       up: [
    //         {
    //           up: key,
    //           nombre: up[key].nombre,
    //           roles: [
    //             { nombre: 'propietario' }
    //           ]
    //         }
    //       ]
    //     }
    //   },
    //     bp[key].up = key;

    //   up[key].bp.push({
    //       id: kdep,
    //       nombre: `${bp[kdep].bpNombre} ${bp[kdep].id}`,
    //       ua: bp[kdep].ua,
    //       uaNombre: bp[kdep].uaNombre,
    //       tipo: bp[kdep].bp
    //     })
    //   up[key].coeficiente += bp[kdep].coeficiente
    //   bp[kdep].up = key;

    //   up[key].bp.push({
    //     id: kpar,
    //     nombre: `${bp[kpar].bpNombre} ${bp[kpar].id}`,
    //     ua: bp[kpar].ua,
    //     uaNombre: bp[kpar].uaNombre,
    //     tipo: bp[kpar].bp
    //   })
    //   up[key].coeficiente += bp[kpar].coeficiente
    //   bp[kpar].up = key;
    //   if (bp[kpar].bp == 'Parqueadero_Sencillo') {

    //     up[key].bp.push({
    //       id: koutpar,
    //       nombre: `${bp[koutpar].bpNombre} ${bp[koutpar].id}`,
    //       ua: bp[koutpar].ua,
    //       uaNombre: bp[koutpar].uaNombre,
    //       tipo: bp[koutpar].bp
    //     })
    //     up[key].coeficiente += bp[koutpar].coeficiente
    //     bp[koutpar].up = key;
    //   }
    //   clienteId++;
    // });
    // Object.keys(bp).filter((k: any) => bp[k].bp == 3 && bp[k].bp == 'Casa_A').forEach((key: any) => {
    //   let apto = bp[key];
    //   let kpar: any = Object.keys(bp).filter((k: any) => bp[k].bp == 4 && bp[k].ua == 'S2' && !bp[k].up)
    //   up[key] = {
    //     nombre: key,
    //     propietario: `CC${users[clienteId].id}`,
    //     nombrePropietario: `${users[clienteId].primerNombre} ${users[clienteId].primerApellido}`,
    //     ua: apto.ua,
    //     uaNombre: estructura[apto.ua].nombre,
    //     bp: [
    //       {
    //         id: key,
    //         nombre: `${apto.bpNombre} ${apto.id}`,
    //         ua: apto.ua,
    //         uaNombre:apto.uaNombre,
    //         tipo: apto.bp
    //       }],
    //     coeficiente: apto.coeficiente
    //   }
    //   users[clienteId].propiedades = {
    //     '564782345-9': {
    //       roles: [
    //       ],
    //       up: [
    //         {
    //           up: key,
    //           nombre: up[key].nombre,
    //           roles: [
    //             { nombre: 'propietario' }
    //           ]
    //         }
    //       ]
    //     }
    //   },
    //     bp[key].up = key;
    //   up[key].bp.push({
    //     id: kpar[0],
    //     nombre: `${bp[kpar[0]].bpNombre} ${bp[kpar[0]].id}`,
    //     ua: bp[kpar[0]].ua,
    //     uaNombre: bp[kpar[0]].uaNombre,
    //     tipo: bp[kpar[0]].bp
    //   })
    //   up[key].coeficiente += bp[kpar[0]].coeficiente
    //   bp[kpar[0]].up = key;
    //   up[key].bp.push({
    //     id: kpar[1],
    //     nombre: `${bp[kpar[1]].bpNombre} ${bp[kpar[1]].id}`,
    //     ua: bp[kpar[1]].ua,
    //     uaNombre: bp[kpar[1]].uaNombre,
    //     tipo: bp[kpar[1]].bp
    //   })
    //   up[key].coeficiente += bp[kpar[1]].coeficiente
    //   bp[kpar[1]].up = key;
    //   clienteId++;
    // });
    // Object.keys(bp).filter((k: any) => bp[k].bp == 3 && bp[k].bp == 'Casa_B').forEach((key: any, index) => {
    //   let apto = bp[key];
    //   let kpar: any = Object.keys(bp).filter((k: any) => bp[k].bp == 4 && bp[k].ua == 'S1' && !bp[k].up)
    //   up[key] = {
    //     nombre: key,
    //     propietario: `CC${users[clienteId].id}`,
    //     nombrePropietario: `${users[clienteId].primerNombre} ${users[clienteId].primerApellido}`,
    //     ua: apto.ua,
    //     uaNombre: estructura[apto.ua].nombre,
    //     bp: [{
    //         id: key,
    //         nombre: `${apto.bpNombre} ${apto.id}`,
    //         ua: apto.ua,
    //       uaNombre: apto.uaNombre,
    //         tipo: apto.bp
    //       }],
    //     coeficiente: apto.coeficiente
    //   }
    //   users[clienteId].propiedades = {
    //     '564782345-9': {
    //       roles: [
    //       ],
    //       up: [
    //         {
    //           up: key,
    //           nombre: up[key]+' '+up[key].nombre,
    //           roles: [
    //             { nombre: 'propietario' }
    //           ]
    //         }
    //       ]
    //     }
    //   },
    //     bp[key].up = key;

    //   up[key].bp.push({
    //     id: kpar[0],
    //     nombre: `${bp[kpar[0]].bpNombre} ${bp[kpar[0]].id}`,
    //     ua: bp[kpar[0]].ua,
    //     uaNombre: bp[kpar[0]].uaNombre,
    //     tipo: bp[kpar[0]].bp
    //   })
    //   up[key].coeficiente += bp[kpar[0]].coeficiente
    //   bp[kpar[0]].up = key;
    //   if (index % 2 !== 1) {

    //     up[key].bp.push({
    //       id: kpar[1],
    //       nombre: `${bp[kpar[1]].bpNombre} ${bp[kpar[1]].id}`,
    //       ua: bp[kpar[1]].ua,
    //       uaNombre: bp[kpar[1]].uaNombre,
    //       tipo: bp[kpar[1]].bp
    //     })
    //     up[key].coeficiente += bp[kpar[1]].coeficiente
    //     bp[kpar[1]].up = key;
    //   }
    //   clienteId++;
    // });
    // let left = Object.values(bp).filter((ele: any) => !ele.up)
    // let coefT = Object.values(bp).reduce((acc, ele: any) => acc + ele.coeficiente, 0)
    // let coefUP = Object.values(up).reduce((acc, ele: any) => acc + ele.coeficiente, 0)
    // let mT = Object.values(bp).reduce((acc, ele: any) => {
    //   return acc + tiposBP[ele.tipoBP].areaConstruida
    // }, 0)
    // let bc = {
    //   Zona_Piscina_1: {
    //     nombre: 'Zona Piscina 1',
    //     tipo: 'Piscina',
    //     exclusivo: false,
    //     sectorizado: false,
    //     reservable: false,
    //     esencial: false,
    //     horarios: {
    //       0: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       1: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       2: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       3: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       4: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       5: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       7: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //     },
    //     funcionando: true,
    //   },
    //   Jacuzzi_1: {
    //     nombre: 'Zona Piscina 1',
    //     tipo: 'Jacuzzi',
    //     exclusivo: false,
    //     sectorizado: true,
    //     asignado: 'E1T1',
    //     reservable: true,
    //     esencial: false,
    //     horarios: {
    //       0: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       1: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       2: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       3: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       4: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       5: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       7: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //     },
    //     precio: 0,
    //     funcionando: true,
    //   },
    //   Jacuzzi_2: {
    //     nombre: 'Jacuzzi 2',
    //     tipo: 'Jacuzzi',
    //     exclusivo: false,
    //     sectorizado: true,
    //     asignado: 'E1T2',
    //     reservable: true,
    //     esencial: false,
    //     horarios: {
    //       0: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       1: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       2: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       3: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       4: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       5: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       7: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //     },
    //     precio: 0,
    //     funcionando: true,
    //   },
    //   Jacuzzi_3: {
    //     nombre: 'Jacuzzi 3',
    //     tipo: 'Jacuzzi',
    //     exclusivo: false,
    //     sectorizado: true,
    //     asignado: 'E1T3',
    //     reservable: true,
    //     esencial: false,
    //     horarios: {
    //       0: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       1: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       2: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       3: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       4: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       5: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       7: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //     },
    //     precio: 0,
    //     funcionando: true,
    //   },
    //   Jacuzzi_4: {
    //     nombre: 'Jacuzzi 4',
    //     tipo: 'Jacuzzi',
    //     exclusivo: false,
    //     sectorizado: true,
    //     asignado: 'E1T4',
    //     reservable: true,
    //     esencial: false,
    //     horarios: {
    //       0: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       1: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       2: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       3: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       4: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       5: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       7: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //     },
    //     precio: 0,
    //     funcionando: false,
    //     reason: 'Mantenimiento'
    //   },
    //   BBQ_1: {
    //     nombre: 'BBQ 1',
    //     tipo: 'BBQ',
    //     exclusivo: false,
    //     sectorizado: false,
    //     reservable: true,
    //     esencial: false,
    //     horarios: {
    //       0: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       1: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       2: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       3: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       4: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       5: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       7: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //     },
    //     precio: 20000,
    //     funcionando: true,
    //   },
    //   BBQ_2: {
    //     nombre: 'BBQ 2',
    //     tipo: 'BBQ',
    //     exclusivo: false,
    //     sectorizado: false,
    //     reservable: true,
    //     esencial: false,
    //     horarios: {
    //       0: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       1: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       2: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       3: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       4: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       5: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       7: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //     },
    //     precio: 20000,
    //     funcionando: true,
    //   },
    //   Cancha_Tennis_1: {
    //     nombre: 'Cancha de Tennis',
    //     tipo: 'Cancha_Tennis',
    //     exclusivo: false,
    //     sectorizado: false,
    //     reservable: true,
    //     esencial: false,
    //     horarios: {
    //       0: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       1: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       2: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       3: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       4: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       5: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //       7: {
    //         rangos: [
    //           {
    //             inicio: 6,
    //             fin: 11
    //           },
    //           {
    //             inicio: 13.5,
    //             fin: 15
    //           }
    //         ],
    //         intervalo: 0.5
    //       },
    //     },
    //     precio: 0,
    //     funcionando: true,
    //   },
    //   Parque_Ninos_1: {
    //     nombre: 'Parque para niños',
    //     tipo: 'Parque_Ninos',
    //     exclusivo: false,
    //     sectorizado: false,
    //     reservable: false,
    //     esencial: false,
    //     funcionando: true,
    //   },
    // }
    // for (let i = 1; i <= 20; i++) {
    //   bc[`Parqueadero_Visitantes_${i}`] = {
    //     nombre: 'V1',
    //     tipo: 'Parqueadero_Visitantes',
    //     exclusivo: false,
    //     sectorizado: false,
    //     reservable: false,
    //     esencial: false,
    //     funcionando: true,
    //   }
    // }
    // for (let i = 1; i <= 20; i++) {
    //   bc[`Bicicletero_${i}`] = {
    //     nombre: `Bicicletero ${i}`,
    //     tipo: 'Bicicletero',
    //     exclusivo: true,
    //     sectorizado: false,
    //     reservable: false,
    //     esencial: false,
    //     funcionando: true,
    //   }
    // }
    // bc['Bicicletero_1'].asignado = 'E1T4A104'
    // bc['Bicicletero_2'].asignado = 'E1T4A302'
    // bc['Bicicletero_3'].asignado = 'E1T1A102'
    // bc['Bicicletero_4'].asignado = 'E1T2A504'

    // for (let i = 1; i <= 4; i++) {
    //   bc[`Ascensor_${i}`] = {
    //     nombre: `Ascensor ${i}`,
    //     tipo: 'Ascensor',
    //     exclusivo: false,
    //     sectorizado: true,
    //     reservable: false,
    //     esencial: true,
    //     asignado: `E1T${i}`,
    //     funcionando: true,
    //   }
    // }

    // up['E1T1A101'].propietario = "CC6962587149"
    // up['E1T1A101'].nombrePropietario = "Kane Graham"
    // up['E1T1A101'].residentes=[]
    // for (let i = 0; i < 4; i++) {
    //   let user = users[users.length - 3 - i]
    //   up['E1T1A101'].residentes.push({
    //     id:user.tipoID+user.id,
    //     nombre:user.primerNombre+' '+user.primerApellido
    //   })
    // }
    // up['E1T1A102'].propietario = "CC6962587149"
    // up['E1T1A102'].nombrePropietario = "Kane Graham"
    // up['E1T1A103'].propietario = "CC9886257621"
    // up['E1T1A103'].nombrePropietario = "Astra Rocha"

    // console.log('reporte bienes', left, bp, up, coefT, coefUP, mT, bc, 'largo', Object.keys(up).length)
    // this.addDocConIdFb(prop.nit, '/empresas', prop)
    // this.addDocConIdFb('definicionPropiedad', '/global', global)
    // this.addDocConIdFb('definicionPropiedad', '/empresas/564782345-9/local', local)
    // users.forEach(user => {
    //   this.addDocConIdFb(`CC${user.id}`, '/personas', {
    //     ...user,
    //     nacionalidad: 'Colombia'
    //   })
    //   this.addDocConIdFb(`CC${user.id}`, '/empresas/564782345-9/personas', {
    //     ...user,
    //     nacionalidad: 'Colombia',
    //   })
    // })
    // Object.keys(bp).forEach((key: any) => {
    //   let ele = bp[key];
    //   this.addDocConIdFb(key, '/empresas/564782345-9/bienesPrivados', ele)
    // })
    // Object.keys(up).forEach((key: any) => {
    //   let ele = up[key];
    //   this.addDocConIdFb(key, '/empresas/564782345-9/unidadesPrivadas', ele)
    // })
    // Object.keys(tiposBP).forEach((key: any) => {
    //   let ele = tiposBP[key];
    //   this.addDocConIdFb(key, '/empresas/564782345-9/tiposBP', ele)
    // })
    // Object.keys(estructura).forEach((key: any) => {
    //   let ele = estructura[key];
    //   this.addDocConIdFb(key, '/empresas/564782345-9/estructura', ele)
    // })
    // Object.keys(bc).forEach((key: any) => {
    //   let ele = bc[key];
    //   this.addDocConIdFb(key, '/empresas/564782345-9/bienesComunes', ele)
    // })
  }


  //Se suscribe a Coleccion recibe link de fb retorna suscripcion a toda la coleccion
  public getCollectionFB(plink) {
    return this.db
      .collection(plink)
      .valueChanges();
  }
  public getCollectionWhereFB(plink, pnomcampofil, pvalcampofil) {
    console.log('plink,pnomcampofil,pvalcampofil', plink, pnomcampofil, pvalcampofil)
    return this.db
      .collection(plink, ref => ref.where(pnomcampofil, '==', pvalcampofil))
      .snapshotChanges()
      .pipe(
        map(actions =>
          actions.map((a: any) => {
            let data = a.payload.doc.data();
            const id = a.payload.doc.id;
            data.id_reg = id;
            return data;
          })
        )
      );
  }

  //Se suscribe a Coleccion recibe link de fb retorna suscripcion a toda la coleccion y trae los ids
  public getCollectionFBIds(plink) {
    console.log('en getCollectionFB');
    return this.db
      .collection(plink)
      .snapshotChanges()
      .pipe(
        map(actions =>
          actions.map((a: any) => {
            let data = a.payload.doc.data();
            const id = a.payload.doc.id;
            data.id_reg = id;
            return data;
          })
        )
      );
  }

  // Subscripcion a colleccion con ids, limitando el numero de registros que trae
  public getCollectionIdFBLimited(plink, limit: number) {
    return this.db
      .collection(plink, ref => ref.limit(limit))
      .snapshotChanges()
      .pipe(
        map(actions =>
          actions.map((a: any) => {
            var data = a.payload.doc.data();
            const id = a.payload.doc.id;
            data.id_reg = id;
            return data;
          })
        )
      );
  }

  // get collection con paginacion en firebase
  public getColLim(plink, filters, orders, lim, doc?, direction?) {
    console.log(orders)
    return this.db.collection(plink, ref => {
      let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      filters.forEach(filter => {
        query = query.where(filter.name, filter.comparator, filter.value);
      });
      orders.forEach(order => {
        query = query.orderBy(order.field, order.dir);
      });
      query = query.limit(lim)
      if (doc) {
        query = direction ? query.startAfter(doc) : query.startAt(doc)
      }
      return query;
    }).snapshotChanges()
  }


  public getRefOnce(ref) {
    let r = this.db.collection("d").doc("d");
    r.ref = ref;
    return r.valueChanges().pipe(first()).toPromise();
  }
  public getRefOnceId(ref) {
    console.log(ref)
    let r = this.db.collection("d").doc("d");
    r.ref = ref;
    return r.snapshotChanges().pipe(first()).toPromise();
  }

  public genRef(plink, id) {
    let ref = this.db.collection(plink).doc(id);
    return ref.ref;
  }


  //Se suscribe a Coleccion recibe link y filtro de un campo de fb retorna suscripcion a toda la coleccion
  //adiciona el id y los datos los deja en data
  public getCollectionIdWhereFB(plink, pnomcampofil, pvalcampofil, sign) {
    console.log(plink)
    return this.db
      .collection(plink, ref => ref.where(pnomcampofil, sign, pvalcampofil))
      .snapshotChanges()
      .pipe(
        map(actions =>
          actions.map((a: any) => {
            // console.log(a);
            var data = a.payload.doc.data();
            const id = a.payload.doc.id;
            // console.log(id,data);
            data.id_reg = id;
            return data;
          })
        )
      );
  }

  //Adiciona registro o documento a colección con id recibido
  public addDocConIdFb(idt, plink, objdatos) {
    console.log('addDocConIdFb ', plink, idt, objdatos);
    return this.db.collection(plink).doc(idt).set(objdatos);
  }
  //Adiciona registro o documento a colección din id, genera el id
  public addDocSinIdFb(plink, objdatos) {
    console.log('addDocSinIdFb ', objdatos);
    this.db.collection(plink).add(objdatos);
  }
  //Actualiza documento coleccion
  public actDocFb(idt, plink, objdatos) {
    console.log('actDocFb ', idt, plink, objdatos);
    return this.db.collection(plink).doc(idt).update(objdatos);
  }
  //Actualiza documento coleccion
  public actArrayDocFb(idt, plink, objdatos, key) {
    const obj = {}
    obj[key] = firestore.FieldValue.arrayUnion(objdatos)
    console.log('actDocFb ', idt, plink, objdatos);
    this.db.collection(plink).doc(idt).update(obj
    );
  }

  //genera un id automatico de firebase
  public genId() {
    return this.db.createId()
  }
  //Borra documento de una coleccion
  public deleteDocFb(plink, idt) {
    this.db.collection(plink).doc(idt).delete();
  }

  public getDocumentById(plink, idt) {

    return this.db.collection(plink).doc(idt).valueChanges();
  }
  public getDocOnce(plink, id) {
    let ref = this.db.collection(plink).doc(id);
    return ref.valueChanges().pipe(first()).toPromise();
  }


  //Consulta una colección con un campo y valor de campo a filtrar retorna suscribción a esta  
  //usado para retornar registros con filtro por un campo
  public consultaCollectionWhereFb(plink, pnomcampo, pvalorcampo, sign) {
    console.log(plink, pnomcampo, pvalorcampo, sign)
    return this.db.collection(plink, ref => ref.where(pnomcampo, sign, pvalorcampo))
      .valueChanges();
  }
  //Consulta una colección con un campo y valor de campo a filtrar retorna suscribción a esta  
  //usado para validadores, con limitacion de numero de registros que trae
  public consultaCollectionWhereFbLimited(plink, pnomcampo, pvalorcampo, sign, limit) {

    return this.db.collection(plink, ref => ref.where(pnomcampo, sign, pvalorcampo).limit(limit))
      .valueChanges().pipe(
        map(arr => {
          return arr;
        }),
      )
  }



  //Consulta una colección con dos o mas campos y valores de campo como una condicion or retorna promesa  
  //con los dos resultados, usado para validacion

  public consultaCollectionWhereManyFb(arrayConsultas: Array<any>) {
    console.log(arrayConsultas);
    const observables = [];
    arrayConsultas.forEach(obj => {
      const link = obj.link;
      const pnomcampo = obj.pnomcampo;
      const pvalorcampo = obj.pvalorcampo;
      const query = this.db.collection(link, ref => ref.where(pnomcampo, '==', pvalorcampo))
        .valueChanges().pipe(first());
      observables.push(query);
    });
    console.log('observables', observables)

    const joint = forkJoin(observables);
    return joint;

  }


  //FUNCIONES PROYECTO DE ACTIVOS ACOPLE
  public async deleteDocFbAsync(plink, idt) {
    // console.log('deleteDocFb ', plink,idt);
    return this.db.collection(plink).doc(idt).delete();
  }
  public addDocSinIdFbBringRef(objdatos, plink) {
    console.log('addDocSinIdFb ', objdatos);
    return new Promise((resolve, reject) => {
      this.db.collection(plink).add(objdatos).then(docRef => {
        this.docId = docRef.id;
        console.log('id del documento', docRef.id) // docRef of type void | DocumentReference
        resolve(docRef.id);
      });
    });
  }
  public async getOneDocument(plink) {
    return this.db.collection(plink, ref => ref.limit(1)).get().toPromise();
  }

  convertirMinuscula(obj, campos: string[]) {
    campos.forEach(campo => {
      obj[campo] = obj[campo].toLowerCase()
    });
    return obj;
  }

  //Consulta una colección con dos campos y valores de campo como una condicion or retorna promesa  
  //con los dos resultados, usado para validacion
  public consultaCollectionWhereDosCamposOrFb(plink, pnomcampo1, pvalorcampo1, pnomcampo2, pvalorcampo2) {
    const q1 = this.db.collection(plink, ref => ref.where(pnomcampo1, '==', pvalorcampo1))
      .valueChanges().pipe(first());
    const q2 = this.db.collection(plink, ref => ref.where(pnomcampo2, '==', pvalorcampo2))
      .valueChanges().pipe(first());
    const observables = [q1, q2];
    const joint = forkJoin(observables);
    return joint;
  }

  //Consulta una colección con un campo y valor de campo a filtrar retorna suscribción a esta  
  //retorna un registro usado para validación si existe ya 
  public consultaCollectionWhereValidateFb(plink, pnomcampo, pvalorcampo) {
    console.log('consultaCollectionWhereValidateFb ', plink, pnomcampo, pvalorcampo);
    // return this.db.collection(plink, ref => ref.where('id_tipo', '==', pvalorcampo) )                  
    return this.db.collection(plink, ref => ref.where(pnomcampo, '==', pvalorcampo))
      .valueChanges().pipe(
        debounceTime(500),
        take(1),
        map(arr => {
          return arr;
        }),
      )

  }

  public getCollectionIdFBStartLimited(plink, pnomcam, pvalcam, plimit: number) {
    return this.db
      .collection(plink, ref => ref.where(pnomcam, '>=', pvalcam).where(pnomcam, '<=', pvalcam + '\uf8ff')
        .limit(plimit))
      .snapshotChanges()
      .pipe(
        map(actions =>
          actions.map((a: any) => {
            var data = a.payload.doc.data();
            const id = a.payload.doc.id;
            data.id_reg = id;
            return data;
          })
        )
      );
  }

  //-----------------------------------------------

  //Registra log de cur de coleccion dada recibe pidref para identificar el registro y posteriormente poder filtrar por este
  public regLogFb(plink, datos: any, pidref: any, accion: string, seguimiento: string) {
    const now = new Date();
    const dia = now.getDate();
    const mes = now.getMonth() + 1;
    const ano = now.getFullYear();
    const hora = now.getHours();
    const minutos = now.getMinutes();
    const segundos = now.getSeconds();
    const numaleator = Math.round(Math.random() * (1000 - 1999) + 1000);
    const idlog = ano.toString() + mes.toString() + dia.toString() + hora.toString() + minutos.toString() + segundos.toString() + numaleator.toString();
    // console.log('OappService',this.oapp.usuario);
    const reglog = {
      id: idlog,
      usuario: this.oapp.usuario.firstname + ' ' + this.oapp.usuario.lastname,
      fecha: now,
      id_ref: pidref,
      datos: datos,
      accion: accion,
      seguimiento: seguimiento
    }
    console.log('save fb ', reglog);
    this.db.collection(plink)
      .doc(idlog).set(reglog);
  }

  //Retorna el log de una colección dada con el id referenciado
  public getLogFB(plink: string, pnomcampoidref, pidref: string) {
    console.log('getLogFB', plink, pidref);
    return this.db
      .collection(plink,
        ref => ref.where(pnomcampoidref, '==', pidref))
      // ref => ref.where('id_ref', '==', pidref))
      .valueChanges()
      .pipe(
        map(actions =>
          actions.map((a: any) => {
            const fecha = a.fecha.toDate();
            const fechastr = fecha.toLocaleDateString()
            const horastr = fecha.toLocaleTimeString()
            const fechalog = a.fecha.toDate();
            return { fechalog, fechastr, horastr, ...a };
          })
        )
      );
  }
  //Retorna el log de una colección dada sin condición todo
  public getLogsinCondiFB(plink: string) {
    console.log('getLogFB', plink);
    return this.db
      .collection(plink)
      .valueChanges()
      .pipe(
        map(actions =>
          actions.map((a: any) => {
            const fecha = a.fecha.toDate();
            const fechastr = fecha.toLocaleDateString()
            const horastr = fecha.toLocaleTimeString()
            const fechalog = a.fecha.toDate();
            return { fechalog, fechastr, horastr, ...a };
          })
        )
      );
  }


  public getGroupQuery(groupname, pnomcampo, pvalcampo) {
    return this.db.collectionGroup(groupname, ref => ref.where(pnomcampo, '==', pvalcampo)
      //  .orderBy(porderby, 'desc')
    ).valueChanges();
  }



}
